<template>
  <div class="SubWebPage" v-loading.fullscreen.lock="fullscreenLoading">

      <el-card class="card">
        <div slot="header" class="card-header">
          <h3 class="card-title titleCont">
            <span class="spIcon"></span>
            学期详情
          </h3>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-lg-3 colInfo">
              <label>学期名称</label>
              <div class="colFonts">{{ruleForm.name | flNoValue}}</div>
            </div>
            <div class="col-lg-3 colInfo">
              <label>学年</label>
              <div class="colFonts">{{ruleForm.year | flNoValue}}</div>
            </div>
            <div class="col-lg-3 colInfo">
              <label>学期时间范围</label>
              <div class="colFonts">{{ruleForm.startDate | flNoValue}}
                至
                {{ruleForm.endDate | flNoValue}}</div>
            </div>
            <div class="col-lg-3 colInfo">
              <label>假期时间范围</label>
              <div class="colFonts">{{ruleForm.startHoliday | flNoValue}}
                至
                {{ruleForm.endHoliday | flNoValue}}</div>
            </div>
            <div class="col-lg-3 colInfo">
              <label>授课时间范围</label>
              <div class="colFonts">{{ruleForm.classStartDate | flNoValue}}
                至
                {{ruleForm.classEndDate | flNoValue}}</div>
            </div>
            <div class="col-lg-3 colInfo">
              <label>一周上课天数</label>
              <div class="colFonts">{{ruleForm.daysPerWeek | flNoValue}}</div>
            </div>
            <div class="col-lg-3 colInfo">
              <label>早自修节数</label>
              <div class="colFonts">{{ruleForm.morning | flNoValue}}</div>
            </div>
            <div class="col-lg-3 colInfo">
              <label>晚自修节数</label>
              <div class="colFonts">{{ruleForm.evening | flNoValue}}</div>
            </div>
            <div class="col-lg-3 colInfo">
              <label>上午节数</label>
              <div class="colFonts">{{ruleForm.forenoon | flNoValue}}</div>
            </div>
            <div class="col-lg-3 colInfo">
              <label>下午节数</label>
              <div class="colFonts">{{ruleForm.afternoon | flNoValue}}</div>
            </div>
            <div class="col-lg-12 colInfo">
              <label>备注</label>
              <div class="colFonts" v-if="ruleForm.remark!=null && ruleForm.remark.length>0" v-html="ruleForm.remark">
              </div>
              <div class="colFonts" v-else>暂无数据</div>
            </div>
          </div>

        </div>
      </el-card>
     <div class="pt-10">
          <el-button icon="el-icon-back" @click="onBack()">返回</el-button>
        </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        fullscreenLoading: false,
        ruleForm: {
          semesterId: '',
          name: '',
          year: '',
          startDate: '',
          endDate: '',
          startHoliday: '',
          endHoliday: '',
          remark: '',
        },
      };
    },
    methods: {
      // 返回
      onBack() {
        let _this = this;
        back(_this);
      },
    },
    filters: {
      flNoValue(obj) {
        if (obj == null || typeof(obj) == "undefined" || obj == '') {
          return '暂无数据';
        }
        return obj;
      }
    },
    created() {
      let _this = this;
      // 班级ID
      let dataID = _this.$route.params.id;

      //判断是否有传值过来
      if (dataID != null && typeof(dataID) != "undefined" && dataID != "") {
        _this.ruleForm.semesterId = dataID;
        var apiUrl = '/api/admin/semester/' + dataID;
        _this.fullscreenLoading = true;
        ajaxGet(_this, apiUrl, null, function(obj) {
          _this.ruleForm.name = obj.name;
          _this.ruleForm.year = obj.year;
          _this.ruleForm.daysPerWeek = obj.daysPerWeek;
          _this.ruleForm.morning = obj.morning;
          _this.ruleForm.forenoon = obj.forenoon;
          _this.ruleForm.evening = obj.evening;
          _this.ruleForm.afternoon = obj.afternoon;
          _this.ruleForm.startDate = dateFormat(obj.startDate);
          _this.ruleForm.endDate = dateFormat(obj.endDate);
          _this.ruleForm.startHoliday = dateFormat(obj.startHoliday);
          _this.ruleForm.endHoliday = dateFormat(obj.endHoliday);
          _this.ruleForm.classStartDate = dateFormat(obj.classStartDate);
          _this.ruleForm.classEndDate = dateFormat(obj.classEndDate);
          _this.ruleForm.remark = obj.remark;
          _this.fullscreenLoading = false;
        });
      } else {
        _this.back();
      }
    }
  }
</script>

<style>
</style>
